import { useCallback, useEffect, useState } from 'react';
import { isApiError } from '@aiptyg/types';
import { getAdminDashboardOverview } from '../services/dashboard.service';
import type { DashboardOverviewDTO } from '../types/dashboard.types';

const ERROR_MAP: Record<string, string> = {
  admin_role_required: '无管理员权限',
  network_error: '网络连接失败，请检查网络',
};

function resolveError(error: unknown): string {
  if (isApiError(error)) {
    return ERROR_MAP[error.message] ?? `加载首页数据失败 (${error.message})`;
  }
  return '加载首页数据失败';
}

export function useAdminDashboardOverview() {
  const [data, setData] = useState<DashboardOverviewDTO | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await getAdminDashboardOverview();
      setData(result);
    } catch (err) {
      setError(resolveError(err));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  return {
    data,
    loading,
    error,
    reload: load,
  };
}
